import {Button,ButtonProps} from "@chakra-ui/react";

export const ProductReviewCardButton = ({
  buttonLabel,
  ...props
}: ButtonProps & {
  buttonLabel?: string;
  href: string;
}) => (
  <Button
    as="a"
    target="_blank"
    bg="blue.600"
    colorScheme="blue"
    boxShadow="base"
    size="lg"
    sx={{
      ":not(:hover)": { color: "blue.50", bg: "blue.400" },
    }}
    _focus={{ boxShadow: "none" }}
    _focusVisible={{ boxShadow: "outline" }}
    _hover={{
      textDecoration: "none",
    }}
    {...props}
  >
    {buttonLabel ?? "Check Price"}
  </Button>
);
